import { useTranslation } from 'react-i18next';

import { useAuthUser } from 'auth/hooks';
import { ApprovedVendors, CompanySettingsLayout } from 'companySettings/components';
import { canAccessCompanySettings } from 'companySettings/utils';
import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';

export const ApprovedVendorsPage = () => {
  const { t } = useTranslation();

  const { user, isLoading } = useAuthUser();

  const title = t('titleApprovedVendors');

  // `user` is hydrated synchronously from localStorage, so a returning session is decided on the
  // first render; deciding on `isFetched` instead would mount the grid (and fire its list request)
  // before the gate runs. A genuinely unknown user waits on an empty shell.
  if (isLoading) {
    return <PageLayout title={title} />;
  }

  if (!canAccessCompanySettings(user)) {
    return (
      <PageLayout title={title}>
        <Error statusCode={StatusCode.ACCESS_DENIED} />
      </PageLayout>
    );
  }

  return (
    <CompanySettingsLayout title={title}>
      <ApprovedVendors />
    </CompanySettingsLayout>
  );
};
